// Temporary feature flags.
// ARRIVAL_VALIDITY_ENABLED: set to true to restore the arrival validity check
// feature (recalc validity dialog/buttons, row actions, rules page, side menu).
export const ARRIVAL_VALIDITY_ENABLED = false;
export const ARRIVAL_VALIDITY_MASTER_PAGE_ENABLED = true;
